module.exports = __webpack_public_path__ + "static/media/clock-gray.ad42b132.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/clock-gray.svg
// module id = 755
// module chunks = 0